import { getCatalogItemById } from "@biosany/shared"
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { isProduction } from "./env"

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

/**
 * Construye la URL de una imagen servida desde `public/images/`, respetando el
 * base path de Vite (`import.meta.env.BASE_URL`). En producción la base es `/`;
 * en los previews bajo subruta es `/previews/<rama>/`, de modo que los assets
 * resuelven correctamente en ambos entornos.
 *
 * @param path Ruta dentro de `images/` (sin el prefijo `/images`).
 *             Ej: `imageBaseURL("products/consulta.jpg")`.
 */
export function imageBaseURL(path: string): string {
	return `${import.meta.env.BASE_URL}images/${path}`
}

/**
 * Hace scroll suave hasta la siguiente sección: el `nextElementSibling` de la
 * sección recibida. Respeta `prefers-reduced-motion`. Reutilizado por los heroes
 * (inicio y ficha de producto) para el CTA de tipo "scroll" / "Leer más".
 */
export function scrollToNextSection(current: HTMLElement | null): void {
	const next = current?.nextElementSibling
	if (!next) return
	const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
	next.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" })
}

/**
 * Price ID de Stripe de un ítem de catálogo (producto, servicio o tratamiento) según el
 * entorno — en producción el real, si no el de prueba (`CATALOG_ITEMS` en
 * `packages/shared/src/catalog-prices.ts` es la única fuente; no repitas un priceId
 * literal fuera de ahí). Para tratamientos, `catalogId` es el id por paquete
 * (`treatmentCatalogId(id, weeks)`), no el `TreatmentId` a secas.
 */
export function catalogPriceId(catalogId: string): string {
	const entry = getCatalogItemById(catalogId)
	if (!entry) throw new Error(`catalogPriceId: catalogId desconocido "${catalogId}"`)
	return isProduction() ? entry.livePriceId : entry.testPriceId
}
